import { render, staticRenderFns } from "./UserDashboardActiveThreadsListItem.vue?vue&type=template&id=0b5f721a"
import script from "./UserDashboardActiveThreadsListItem.vue?vue&type=script&lang=js"
export * from "./UserDashboardActiveThreadsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports